import queryString from 'qs'
import { AppThunk } from '../../../model/model'
import { slice } from '../slice'

const setActiveBrandInUrl = (brandActive: string | null) => {
  const parsedSearch = queryString.parse(window.location.search, {
    ignoreQueryPrefix: true,
  })
  parsedSearch['activeBrand'] = brandActive || undefined
  const urlParams = queryString.stringify(parsedSearch)
  if (urlParams) {
    window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`)
  }
}

export const setActiveBrandAction = (activeBrand: string | null, syncChange = true): AppThunk => {
  return dispatch => {
    setActiveBrandInUrl(activeBrand)
    dispatch(
      !syncChange
        ? slice.actions.setActiveBrandCodeActionWithoutSync(activeBrand)
        : slice.actions.setActiveBrandCodeAction(activeBrand),
    )
  }
}
